<template>
  <div class="max-w-6xl mx-auto mt-10 mb-10">
    <div class="flex flex-col justify-center">
      <p class="text-xs text-center">Get in touch</p>
      <div
        class="font-sans text-xl font-semibold text-center md:text-center md:font-bold md:text-3xl"
      >
        Contact Us
      </div>
    </div>

    <div class="grid mt-5 md:grid-cols-2">
      <div class="flex flex-col md:w-[28rem]">
        <p class="pb-4 font-semibold">
          For any further questions, enquiries or to book <br />
          a property viewing, visit or call us;
        </p>
        <p class="pb-4 text-sm">
          Number 2 Serwaa Plaza 2 <br />
          Batsona - Spintex, Accra
        </p>
        <div class="flex space-x-5">
          <p class="inline-flex m-0 text-sm w-28">Office line:</p>
          <p class="inline-flex flex-wrap m-0 text-sm">
            <span>+233 (0)302 805 495</span> | <span>US +1 (929) 358 4506</span>
          </p>
        </div>
        <div class="flex pb-4 space-x-5">
          <p class="inline-flex m-0 text-sm w-28">WhatsApp (only):</p>
          <p class="inline-flex m-0 text-sm">+233 (0)209 162 231</p>
        </div>

        <div class="flex pb-4 space-x-5">
          <p class="inline-flex m-0 text-sm w-28">Email:</p>
          <p class="inline-flex m-0 text-sm">hello@hutloop.com</p>
        </div>
        <img src="@/assets/images/contacts.jpg" alt="contact-us" class="mt-3" />
        <p class="mt-5 text-sm">
          Follow us on social media to learn what we're up to!
        </p>
      </div>
      <div class="flex flex-col space-y-3">
        <p
          v-show="showMessage"
          :class="['text-sm', 'font-semibold', 'text-center', messageClass]"
        >
          {{ message }}
        </p>
        <div>
          <label for="name" class="text-xs font-light text-gray-600 uppercase"
            >Name (*)</label
          >
          <input
            type="text"
            v-model="name"
            class="w-full h-12 px-4 shadow outline-none border-primary focus:outline bg-gray-50 focus:ring-0 focus:border-b"
            id="name"
          />
        </div>
        <div>
          <label for="email" class="text-xs font-light text-gray-600 uppercase"
            >Email (*)</label
          >
          <input
            type="email"
            v-model="email"
            class="w-full h-12 px-4 shadow outline-none border-primary focus:outline bg-gray-50 focus:ring-0 focus:border-b"
            id="email"
          />
        </div>
        <div>
          <label
            for="comment"
            class="text-xs font-light text-gray-600 uppercase"
            >Comment (*)</label
          >
          <textarea
            v-model="description"
            class="w-full p-4 shadow outline-none border-primary focus:outline bg-gray-50 focus:ring-0 focus:border-b"
            id="comment"
            rows="8"
          ></textarea>
          <button
            @click="submitRequest"
            class="flex items-center justify-center w-40 p-2 mt-10 text-white uppercase rounded-sm bg-secondary h-14"
          >
            Send message
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      email: null,
      name: null,
      description: null,
      base_url: this.$store.state.baseUrl,
      message: null,
      showMessage: false,
      isError: false,
    };
  },
  computed: {
    messageClass() {
      return this.isError ? "text-red-500" : "text-teal-600";
    },
  },
  methods: {
    submitRequest() {
      if (this.email != null) {
        axios
          .post(`${this.base_url}property-report`, {
            email: this.email,
            name: this.name,
            description: this.description,
          })
          .then((response) => {
            this.message = response.data.message;
            this.showMessage = true;
            this.isError = false;
            (this.email = null),
              (this.name = null),
              (this.description = null),
              setTimeout(() => {
                this.message = null;
                this.showMessage = false;
              }, 5000);
          })
          .catch((error) => console.log(error));
      } else {
        this.showMessage = true;
        this.isError = true;
        this.message = "enter your email";
      }
    },
  },
};
</script>
